var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.toasts.length > 0
    ? _c(
        "div",
        { staticClass: "crash-notifications" },
        [
          _c(
            "transition-group",
            {
              staticClass: "notifications-list",
              attrs: { name: "toast-anim", tag: "div" },
            },
            _vm._l(_vm.toasts, function (t) {
              return _c(
                "div",
                {
                  key: t.id,
                  staticClass: "toast-item",
                  class: { "slide-right": t.slideRight },
                },
                [
                  _c("div", { staticClass: "avatar-wrapper" }, [
                    _c("img", {
                      staticClass: "avatar-img",
                      attrs: { src: _vm.getAvatarUrl(t.avatar), alt: "avatar" },
                    }),
                    _c("div", { staticClass: "badge" }, [
                      _c("span", { staticClass: "badge-text" }, [
                        _vm._v(_vm._s(_vm.formatMultiplier(t.multiplier))),
                      ]),
                    ]),
                  ]),
                  _c("i", { staticClass: "icon icon_aim aim-icon" }),
                  _c("div", { staticClass: "user-info" }, [
                    _c("img", {
                      staticClass: "gun-icon",
                      attrs: { src: _vm.gunSvgUrl, alt: "gun" },
                    }),
                    _c(
                      "span",
                      { staticClass: "nickname", attrs: { title: t.name } },
                      [_vm._v(" " + _vm._s(t.name) + " ")]
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }